import * as React from "react";
import type { SVGProps } from "react";
const SvgThumbsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={64}
    fill="none"
    {...props}
  >
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M33.004 1.821C15.33 1.821 1 13.777 1 28.535c0 14.757 14.33 26.713 32.004 26.713a37.93 37.93 0 0 0 10.101-1.36l7.198 7.021c.62.559.674.62 1.002.91.876.768 1.276.159 1.276-.412V49.66h-.006C60.135 44.775 65 37.129 65 28.533 65 13.777 50.674 1.82 33.002 1.82l.002.001Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M36.527 14.44c2.837-1.644 4.858 4.32 2.443 7.144-.547.64.027.504 1.156.504l3.759.005c6.672.006 4.295 18.277-.888 18.255l-8.98-.033c-2.821-.016-5.762-1.907-6.65-3.558v-14.56l9.16-7.756Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M20.064 20.459h5.587c.943 0 1.716.772 1.716 1.721v15.113c0 .943-.773 1.715-1.716 1.715h-5.587a1.721 1.721 0 0 1-1.716-1.715V22.18c0-.949.773-1.721 1.716-1.721Z"
    />
  </svg>
);
export default SvgThumbsUp;
